document.addEventListener("DOMContentLoaded", function () {
  /* 🟢 ACCORDION FUNCTIONALITY */
  const accordions = document.querySelectorAll(".accordion details");

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", () => {
      // @ts-ignore
      if (accordion.open) {
        accordions.forEach((other) => {
          if (other !== accordion) other.removeAttribute("open");
        });
      }
    });
  });
  /* 🛑 ACCORDION FUNCTIONALITY */

  /* 🟢 VIDEO POPUP FUNCTIONALITY [7.28.25] */
  // Create modal elements
  function createVideoModal() {
    if (document.querySelector(".kcs-video-modal")) return; // Already exists

    const modal = document.createElement("div");
    modal.className = "kcs-video-modal";
    modal.innerHTML = `
            <div class="kcs-video-modal-content">
                <button class="kcs-video-close" aria-label="Close video">&times;</button>
                <video controls autoplay playsinline></video>
            </div>
        `;

    document.body.appendChild(modal);

    // Close modal functionality
    const closeBtn = modal.querySelector(".kcs-video-close");
    closeBtn.addEventListener("click", closeVideoModal);

    // Close on overlay click
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeVideoModal();
      }
    });

    // Close on Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("active")) {
        closeVideoModal();
      }
    });
  }

  // Open video in modal
  function openVideoModal(videoSrc, posterSrc) {
    createVideoModal();
    const modal = document.querySelector(".kcs-video-modal");
    const video = modal.querySelector("video");

    video.src = videoSrc;
    if (posterSrc) {
      video.poster = posterSrc;
    }

    modal.classList.add("active");
    document.body.style.overflow = "hidden"; // Prevent background scroll
  }

  // Close video modal
  function closeVideoModal() {
    const modal = document.querySelector(".kcs-video-modal");
    const video = modal.querySelector("video");

    modal.classList.remove("active");
    video.pause();
    video.src = "";
    document.body.style.overflow = ""; // Restore scroll
  }

  // Intercept deferred media clicks
  document.addEventListener("click", function (e) {
    const deferredMediaButton = e.target.closest(
      ".deferred-media__poster-button"
    );

    if (deferredMediaButton) {
      e.preventDefault();
      e.stopPropagation();

      const deferredMedia = deferredMediaButton.closest("deferred-media");
      const template = deferredMedia.querySelector("template");

      if (template) {
        const videoElement = template.content.querySelector("video");
        const posterImg = deferredMediaButton.querySelector("img");

        if (videoElement) {
          const videoSrc =
            videoElement.querySelector("source")?.src || videoElement.src;
          const posterSrc = posterImg?.src || videoElement.poster;

          if (videoSrc) {
            openVideoModal(videoSrc, posterSrc);
          }
        }
      }
    }
  });
  /* 🛑 VIDEO POPUP FUNCTIONALITY */

  /* 🟢 ASSEMBLY PRICE TOGGLE MANAGER [9.2.25] */
  // Dynamically updates product prices between RTA and ASM variants
  class KCSAssemblyPriceManager {
    constructor() {
      // Use localStorage to persist selection
      this.currentType = this.getStoredPreference();
      this.productCache = new Map();
      this.isUpdating = false;
      this.init();
    }

    getStoredPreference() {
      return localStorage.getItem("kcs_assembly_preference") || "RTA";
    }

    setStoredPreference(type) {
      localStorage.setItem("kcs_assembly_preference", type);
      this.currentType = type;
    }

    init() {
      this.setup();
    }

    setup() {
      // Listen for toggle changes
      document.addEventListener("toggle-change", (e) => {
        const selectedType = e.detail.position === "left" ? "RTA" : "ASM";
        this.handleToggleChange(selectedType);
      });

      // Intercept quick-add for variant pre-selection
      this.interceptQuickAdd();

      // Listen for variant changes on product pages
      this.listenForProductPageVariants();

      // Set initial state
      this.applyInitialToggleState();
      this.updateAllPrices();

      // Show notification on page load
      this.showNotification(true);

      // Watch for new products
      this.observeNewProducts();
    }

    applyInitialToggleState() {
      const toggles = document.querySelectorAll(
        '[class*="ai-toggle-container"]'
      );
      toggles.forEach((toggle) => {
        const leftButton = toggle.querySelector(".left-button");
        const rightButton = toggle.querySelector(".right-button");

        if (this.currentType === "ASM") {
          if (rightButton && !toggle.classList.contains("right")) {
            rightButton.click();
          }
        } else {
          if (leftButton && toggle.classList.contains("right")) {
            leftButton.click();
          }
        }
      });
    }

    handleToggleChange(selectedType) {
      if (this.currentType === selectedType) return;

      this.setStoredPreference(selectedType);
      this.currentType = selectedType;
      this.updateAllPrices();
      this.showNotification();
    }

    async updateAllPrices() {
      if (this.isUpdating) return;
      this.isUpdating = true;

      try {
        // Target ONLY product-card elements, not all data-product-id elements
        const productCards = document.querySelectorAll("product-card");
        console.log(`Updating ${productCards.length} product cards`);

        const batchSize = 10;
        for (let i = 0; i < productCards.length; i += batchSize) {
          const batch = Array.from(productCards).slice(i, i + batchSize);
          await Promise.all(batch.map((card) => this.updateProductCard(card)));

          if (i + batchSize < productCards.length) {
            await new Promise((resolve) => setTimeout(resolve, 50));
          }
        }
      } finally {
        this.isUpdating = false;
      }
    }

    async updateProductCard(card) {
      try {
        const productLink = card.querySelector('a[href*="/products/"]');
        if (!productLink) return;

        const handle = this.extractHandle(productLink.href);
        if (!handle) return;

        const product = await this.getProductData(handle);
        if (!product) return;

        // Check for RTA/ASM variants
        const hasRTA = product.variants.some(
          (v) => v.sku && v.sku.endsWith("-RTA")
        );
        const hasASM = product.variants.some(
          (v) => v.sku && v.sku.endsWith("-ASM")
        );

        let targetVariant;

        if (hasRTA || hasASM) {
          // Has assembly options - find appropriate variant
          targetVariant = this.findTargetVariant(product.variants);
        } else {
          // No assembly options - use default variant (same price in both positions)
          targetVariant =
            product.selected_or_first_available_variant || product.variants[0];
        }

        if (!targetVariant) return;

        this.updateCardPrice(card, targetVariant);
        this.updateCardData(card, targetVariant);

        // Pass assembly options flag to badge update
        this.updateAssemblyBadge(card, hasRTA || hasASM);
      } catch (error) {
        console.error("Error updating card:", error);
      }
    }

    extractHandle(url) {
      const match = url.match(/\/products\/([^?#\/]+)/);
      return match ? match[1] : null;
    }

    async getProductData(handle) {
      if (this.productCache.has(handle)) {
        const cached = this.productCache.get(handle);
        if (Date.now() - cached.timestamp < 300000) {
          return cached.data;
        }
      }

      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error("Fetch failed");

        const product = await response.json();
        this.productCache.set(handle, {
          data: product,
          timestamp: Date.now(),
        });

        return product;
      } catch (error) {
        console.error(`Failed to fetch ${handle}:`, error);
        return null;
      }
    }

    findTargetVariant(variants) {
      const suffix = `-${this.currentType}`;
      // First try to find available variant with correct suffix
      const match = variants.find(
        (v) =>
          v.sku &&
          v.sku.toUpperCase().endsWith(suffix.toUpperCase()) &&
          v.available
      );

      if (match) return match;

      // Then try unavailable variant with correct suffix
      const unavailable = variants.find(
        (v) => v.sku && v.sku.toUpperCase().endsWith(suffix.toUpperCase())
      );

      // Fallback to first available or first variant
      return unavailable || variants.find((v) => v.available) || variants[0];
    }

    updateCardPrice(card, variant) {
      // Find ALL price elements within product-price components
      const priceContainers = card.querySelectorAll("product-price");

      priceContainers.forEach((container) => {
        // Target the sale price specifically
        const priceEl = container.querySelector(
          ".price:not(.compare-at-price)"
        );
        if (!priceEl) return;

        const formatted = this.formatMoney(variant.price);
        priceEl.style.transition = "opacity 0.2s";
        priceEl.style.opacity = "0.5";

        setTimeout(() => {
          priceEl.textContent = formatted;
          priceEl.style.opacity = "1";
        }, 200);
      });
    }

    updateCardData(card, variant) {
      // Store variant ID for quick-add modal
      card.dataset.defaultVariantId = variant.id;

      // Update ALL product links in the card to include variant parameter
      const links = card.querySelectorAll('a[href*="/products/"]');
      links.forEach((link) => {
        const base = link.href.split("?")[0];
        link.href = `${base}?variant=${variant.id}`;
      });
    }

    updateAssemblyBadge(card, hasAssemblyOptions = true) {
      const existing = card.querySelector(".kcs-asm-badge");
      if (existing) existing.remove();

      // Don't show badge if product has no assembly options
      if (!hasAssemblyOptions) return;

      // Check if we're on a product page
      const isProductPage = window.location.pathname.includes("/products/");

      // Create badge/text element
      const badge = document.createElement("div");
      badge.className = "kcs-asm-badge";

      if (isProductPage) {
        // On product pages, show simple italic text
        badge.innerHTML = `
                    <div style="
                        margin-top: 7px;
                        font-style: italic;
                        font-size: 11px;
                        color: rgba(53, 49, 46, 0.5);
                        font-family: 'Figtree', sans-serif;
                    ">
                        ${
                          this.currentType === "RTA"
                            ? "RTA price shown"
                            : "Assembled price shown"
                        }
                    </div>
                `;
      } else {
        // On collection pages, show clickable badges
        badge.innerHTML = `
                    <div style="
                        display: inline-flex;
                        gap: 4px;
                        margin-top: 9px;
                    ">
                        <span class="kcs-rta-button" style="
                            display: inline-block;
                            background: ${
                              this.currentType === "RTA"
                                ? "#35312E"
                                : "transparent"
                            };
                            color: ${
                              this.currentType === "RTA"
                                ? "#FFFFFF"
                                : "rgba(53, 49, 46, 0.7)"
                            };
                            padding: 3.5px 9px;
                            border: 1px solid ${
                              this.currentType === "RTA"
                                ? "#35312E"
                                : "rgba(53, 49, 46, 0.7)"
                            };
                            border-radius: 3px;
                            font-size: 8px;
                            font-weight: 600;
                            text-transform: uppercase;
                            font-family: 'Figtree', sans-serif;
                            letter-spacing: 0.5px;
                            transition: all 0.2s;
                            cursor: pointer;
                        ">RTA</span>
                        <span class="kcs-asm-button" style="
                            display: inline-block;
                            background: ${
                              this.currentType === "ASM"
                                ? "#35312E"
                                : "transparent"
                            };
                            color: ${
                              this.currentType === "ASM"
                                ? "#FFFFFF"
                                : "rgba(53, 49, 46, 0.7)"
                            };
                            padding: 3.5px 9px;
                            border: 1px solid ${
                              this.currentType === "ASM"
                                ? "#35312E"
                                : "rgba(53, 49, 46, 0.7)"
                            };
                            border-radius: 3px;
                            font-size: 8px;
                            font-weight: 600;
                            text-transform: uppercase;
                            font-family: 'Figtree', sans-serif;
                            letter-spacing: 0.5px;
                            transition: all 0.2s;
                            cursor: pointer;
                        ">ASSEMBLED</span>
                    </div>
                `;

        // Add click handlers for collection pages only
        const rtaButton = badge.querySelector(".kcs-rta-button");
        const asmButton = badge.querySelector(".kcs-asm-button");

        if (rtaButton && asmButton) {
          rtaButton.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.currentType !== "RTA") {
              // Trigger the main toggle to RTA position
              const toggle = document.querySelector(
                '[class*="ai-toggle-container"]'
              );
              if (toggle) {
                const leftButton = toggle.querySelector(".left-button");
                if (leftButton) leftButton.click();
              }
            }
          });

          asmButton.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.currentType !== "ASM") {
              // Trigger the main toggle to ASM position
              const toggle = document.querySelector(
                '[class*="ai-toggle-container"]'
              );
              if (toggle) {
                const rightButton = toggle.querySelector(".right-button");
                if (rightButton) rightButton.click();
              }
            }
          });
        }
      }

      // Find the best place to insert the badge (after price)
      const priceContainers = card.querySelectorAll("product-price");
      if (priceContainers.length > 0) {
        // Insert after the last product-price element
        const lastPriceContainer = priceContainers[priceContainers.length - 1];
        lastPriceContainer.parentNode.insertBefore(
          badge,
          lastPriceContainer.nextSibling
        );
      } else {
        // Fallback to card content container
        const container = card.querySelector(
          ".card__info, .product-card__info, .card__content, .group-block-content"
        );
        if (container) container.appendChild(badge);
      }
    }

    listenForProductPageVariants() {
      // Only run on product pages
      if (!window.location.pathname.includes("/products/")) return;

      // Check if current product has RTA/ASM variants
      this.checkMainProductForAssemblyOptions();

      // Listen for the theme's variant update event
      document.addEventListener("variant:update", (e) => {
        console.log("Variant update event detected", e.detail);

        if (!e.detail || !e.detail.resource) return;

        const variant = e.detail.resource;
        const sku = variant.sku || "";
        const title = variant.title || "";

        console.log("Variant SKU:", sku, "Title:", title);

        // Check SKU for RTA/ASM
        let newType = null;
        if (sku.endsWith("-RTA") || title.includes("RTA")) {
          newType = "RTA";
        } else if (sku.endsWith("-ASM") || title.includes("Assembled")) {
          newType = "ASM";
        }

        if (newType && this.currentType !== newType) {
          console.log(`Product page variant changed to ${newType}`);
          this.handleToggleChange(newType);
        }
      });
    }

    checkMainProductForAssemblyOptions() {
      // Check if the main product on this page has RTA/ASM variants
      const variantPicker = document.querySelector("variant-picker");
      if (!variantPicker) {
        // No variant picker means no variants at all
        this.mainProductHasAssemblyOptions = false;
        return;
      }

      const variantOptions = variantPicker.querySelectorAll(
        'input[type="radio"]'
      );
      let hasRTAOption = false;
      let hasASMOption = false;

      variantOptions.forEach((option) => {
        const value = option.value || "";
        const label = option.getAttribute("aria-label") || "";

        if (
          value.includes("RTA") ||
          label.includes("RTA") ||
          value.includes("Ready to assemble")
        ) {
          hasRTAOption = true;
        }
        if (
          value.includes("Assembled") ||
          label.includes("Assembled") ||
          value.includes("ASM")
        ) {
          hasASMOption = true;
        }
      });

      // Store whether main product has assembly options
      this.mainProductHasAssemblyOptions = hasRTAOption || hasASMOption;

      // If no assembly options, remove any existing badges on main product area
      if (!this.mainProductHasAssemblyOptions) {
        // Remove badges from main product area (not product cards)
        const mainProductBadges = document.querySelectorAll(
          ".product-information .kcs-asm-badge, .product__info .kcs-asm-badge"
        );
        mainProductBadges.forEach((badge) => badge.remove());
      }
    }

    interceptQuickAdd() {
      // Intercept form submission to update variant
      document.addEventListener(
        "click",
        (e) => {
          const btn = e.target.closest(
            '.quick-add__button, button[name="add"]'
          );
          if (!btn) return;

          const card = btn.closest("product-card");
          if (!card) return;

          // Update the form's variant input BEFORE submission
          const form = btn.closest("form");
          if (form) {
            const variantInput = form.querySelector('input[name="id"]');
            const defaultVariantId = card.dataset.defaultVariantId;

            if (variantInput && defaultVariantId) {
              variantInput.value = defaultVariantId;
              console.log(
                `Set variant to ${defaultVariantId} for ${this.currentType}`
              );
            }
          }
        },
        true
      ); // Use capture phase to intercept before form submission

      // Watch for modals and pre-select variant
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.matches) {
              if (
                node.matches(
                  ".quick-add__modal, .variant-picker-modal, modal-dialog"
                ) ||
                node.querySelector(
                  ".variant-picker, .variant-option, variant-radios"
                )
              ) {
                setTimeout(() => this.preselectVariant(node), 100);
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    preselectVariant(modal) {
      const assemblyType =
        sessionStorage.getItem("kcs_assembly_type") || this.currentType;

      // Try radio buttons first
      const radios = modal.querySelectorAll(
        'input[type="radio"][name*="option"], input[type="radio"][name*="variant"]'
      );
      radios.forEach((radio) => {
        const label =
          radio.parentElement.querySelector("label") ||
          radio.nextElementSibling ||
          radio.parentElement;
        const text = label ? label.textContent : "";

        if (text.includes(`-${assemblyType}`)) {
          radio.checked = true;
          radio.click();
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      // Try select dropdowns
      const selects = modal.querySelectorAll(
        'select[name*="option"], select[name*="variant"]'
      );
      selects.forEach((select) => {
        const options = select.querySelectorAll("option");
        options.forEach((option) => {
          if (option.textContent.includes(`-${assemblyType}`)) {
            option.selected = true;
            select.value = option.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });

      // Clean up session storage
      sessionStorage.removeItem("kcs_quick_add_variant");
      sessionStorage.removeItem("kcs_assembly_type");
    }

    showNotification(isPageLoad = false) {
      // Show notifications on collection and product pages
      const isCollectionPage =
        window.location.pathname.includes("/collections/");
      const isProductPage = window.location.pathname.includes("/products/");

      if (!isCollectionPage && !isProductPage) return;

      // On product pages, only show notification if main product has assembly options
      if (isProductPage) {
        // Check main product if not already checked
        if (this.mainProductHasAssemblyOptions === undefined) {
          this.checkMainProductForAssemblyOptions();
        }
        // Don't show notification if main product has no assembly options
        if (!this.mainProductHasAssemblyOptions) {
          return;
        }
      }

      const notif = document.createElement("div");
      notif.innerHTML = `
                <div style="
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #FFFFFF;
                    color: #35312E;
                    padding: 12px 20px;
                    border: 1px solid #35312E;
                    border-radius: 4px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                    z-index: 9999;
                    font-size: 14px;
                    font-weight: 500;
                    opacity: 0;
                    transform: translateY(-10px);
                    transition: all ${isPageLoad ? "0.8s" : "0.3s"};
                ">
                    ${
                      this.currentType === "ASM"
                        ? "Fully Assembled"
                        : "Ready to Assemble"
                    } pricing
                </div>
            `;

      document.body.appendChild(notif);

      // Longer delay for page load
      setTimeout(
        () => {
          requestAnimationFrame(() => {
            notif.firstElementChild.style.opacity = "1";
            notif.firstElementChild.style.transform = "translateY(0)";
          });
        },
        isPageLoad ? 500 : 0
      );

      setTimeout(() => {
        notif.firstElementChild.style.opacity = "0";
        notif.firstElementChild.style.transform = "translateY(-10px)";
        setTimeout(() => notif.remove(), 300);
      }, 2500);
    }

    observeNewProducts() {
      const observer = new MutationObserver((mutations) => {
        let hasNew = false;

        mutations.forEach((m) => {
          m.addedNodes.forEach((n) => {
            if (n.nodeType === 1 && n.matches) {
              if (
                n.matches("[data-product-id], product-card") ||
                n.querySelector("[data-product-id], product-card")
              ) {
                hasNew = true;
              }
            }
          });
        });

        if (hasNew) {
          clearTimeout(this.updateTimeout);
          this.updateTimeout = setTimeout(() => this.updateAllPrices(), 500);
        }
      });

      const grids = document.querySelectorAll(
        ".product-grid, .collection-grid, #ResultsList, results-list, .collection-wrapper"
      );

      grids.forEach((grid) => {
        observer.observe(grid, {
          childList: true,
          subtree: true,
        });
      });
    }

    formatMoney(cents) {
      const dollars = cents / 100;
      const isWhole = dollars % 1 === 0;

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(dollars);
    }
  }

  // Initialize
  window.KCSAssemblyManager = new KCSAssemblyPriceManager();

  /* 🛑 ASSEMBLY PRICE TOGGLE MANAGER */
});

// 🟢 COLLECTION FILTER DEFAULT STATE [10.20.25]
// Keep only "Type" and "Color" filters open on page load
document.addEventListener("DOMContentLoaded", function () {
  const filterPanels = document.querySelectorAll(".facets__panel");

  filterPanels.forEach((panel) => {
    const panelId = panel.id || "";
    const summary = panel.querySelector("summary");
    const summaryText = summary ? summary.textContent.trim() : "";

    // Keep "Type" and "Color" filters open, close all others
    const shouldStayOpen =
      panelId.includes("filter-p-product_type") ||
      panelId.includes("filter-p-m-custom-cabinet_finish") ||
      summaryText === "Type" ||
      summaryText === "Color";

    if (!shouldStayOpen && panel.hasAttribute("open")) {
      panel.removeAttribute("open");
    }
  });
});
// 🛑 COLLECTION FILTER DEFAULT STATE

// 🟢 AUTO-EXPAND SUB-CATEGORY WHEN TYPE IS SELECTED [10.20.25]
// Progressive disclosure: when user selects a TYPE filter, auto-open Sub-Category for drill-down
// Auto-collapse when TYPE is cleared (unless Sub-Category has active selections)
document.addEventListener("DOMContentLoaded", function () {
  // Find the TYPE filter panel
  const typeFilterPanel = document.querySelector(
    'details[id*="filter-p-product_type"]'
  );
  // Find the SUB-CATEGORY filter panel
  const subCategoryPanel = document.querySelector(
    'details[id*="filter-p-t-category"]'
  );

  if (!typeFilterPanel || !subCategoryPanel) return;

  // Watch for changes to TYPE filter checkboxes
  const typeCheckboxes = typeFilterPanel.querySelectorAll(
    'input[type="checkbox"]'
  );

  typeCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      // Check if ANY type checkbox is checked
      const hasTypeSelection = Array.from(typeCheckboxes).some(
        (cb) => cb.checked
      );

      if (hasTypeSelection && !subCategoryPanel.hasAttribute("open")) {
        // Open the Sub-Category filter
        subCategoryPanel.setAttribute("open", "");

        // Smooth scroll into view if needed
        setTimeout(() => {
          const rect = subCategoryPanel.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

          if (!isVisible) {
            subCategoryPanel.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
        }, 100);
      }
      // If NO type selections, close Sub-Category ONLY if it has no active selections
      else if (!hasTypeSelection && subCategoryPanel.hasAttribute("open")) {
        const subCategoryCheckboxes = subCategoryPanel.querySelectorAll(
          'input[type="checkbox"]'
        );
        const hasSubCategorySelection = Array.from(subCategoryCheckboxes).some(
          (cb) => cb.checked
        );

        // Only close if Sub-Category has no active selections
        if (!hasSubCategorySelection) {
          subCategoryPanel.removeAttribute("open");
        }
      }
    });
  });
});
// 🛑 AUTO-EXPAND SUB-CATEGORY WHEN TYPE IS SELECTED

// 🟢 MOBILE FILTER DRAWER COMPLETE FIX [10.22.25]
document.addEventListener("DOMContentLoaded", function () {
  // Fix 1: Override clear all button
  function fixDrawerClearButton() {
    const drawerClearBtn = document.querySelector(
      ".facets--drawer .facets__clear-all"
    );
    if (!drawerClearBtn) return;

    // Clone to remove all existing handlers
    const newBtn = drawerClearBtn.cloneNode(true);
    drawerClearBtn.parentNode.replaceChild(newBtn, drawerClearBtn);

    // Add clean handler
    newBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Remove ALL body styles that could lock scrolling
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.removeProperty("position");
      document.body.style.removeProperty("top");

      // Close drawer
      const drawer = document.querySelector(".facets--drawer[open]");
      if (drawer) {
        drawer.removeAttribute("open");
      }

      // Clear the URL and reload
      const baseUrl = window.location.pathname;
      window.location.href = baseUrl;
    });
  }

  // Fix 2: Monitor for last filter removal - NOW WITH PAGE RELOAD
  function watchForLastFilterRemoval() {
    // Watch for filter changes
    document.addEventListener("change", function (e) {
      if (e.target.matches('.facets--drawer input[type="checkbox"]')) {
        setTimeout(() => {
          // Check if any filters remain active
          const activeFilters = document.querySelectorAll(
            '.facets--drawer input:checked:not([name="sort_by"])'
          );
          const drawer = document.querySelector(".facets--drawer[open]");

          if (activeFilters.length === 0 && drawer) {
            console.log(
              "🔓 Last filter removed - reloading page to clear filters"
            );

            // Clean up body styles first
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            // Close drawer
            drawer.removeAttribute("open");

            // RELOAD PAGE - same as Clear All button
            const baseUrl = window.location.pathname;
            window.location.href = baseUrl;
          }
        }, 200);
      }
    });

    // Also watch for X button clicks on last filter
    document.addEventListener("click", function (e) {
      const removeBtn = e.target.closest(
        ".facets--drawer facet-remove-component a"
      );
      if (removeBtn) {
        setTimeout(() => {
          // Check for remaining filters after the X click processes
          const activeCheckboxes = document.querySelectorAll(
            '.facets--drawer input:checked:not([name="sort_by"])'
          );
          const remainingFilterTags = document.querySelectorAll(
            ".facets--drawer .facets-remove facet-remove-component"
          );
          const drawer = document.querySelector(".facets--drawer[open]");

          // If no active checkboxes AND only 1 filter tag left (the one just clicked)
          if (
            activeCheckboxes.length === 0 &&
            remainingFilterTags.length <= 1 &&
            drawer
          ) {
            console.log(
              "🔓 Last filter X clicked - reloading page to clear filters"
            );

            // Clean up body styles first
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            // Close drawer
            drawer.removeAttribute("open");

            // RELOAD PAGE - same as Clear All button
            const baseUrl = window.location.pathname;
            window.location.href = baseUrl;
          }
        }, 300);
      }
    });
  }

  // Fix 3: Emergency body position/top cleanup
  // UPDATED 2025-01-07: Only trigger for filter drawer, not cart popups
  const bodyWatcher = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "style") {
        const body = document.body;
        const filterDrawerOpen = document.querySelector(".facets--drawer[open]");
        
        // Check if ANY drawer/popup is open (cart, quick-add, etc.)
        const anyPopupOpen = document.querySelector(
          '.facets--drawer[open], ' +
          'cart-drawer[open], ' +
          '.cart-drawer[open], ' +
          '.cart-notification[open], ' +
          'cart-notification[open], ' +
          '.drawer[open], ' +
          '.modal[open], ' +
          '[class*="cart"][open], ' +
          '[class*="drawer"][open], ' +
          '[class*="modal"][open], ' +
          '[class*="popup"][aria-hidden="false"], ' +
          '.quick-add-modal:not([hidden])'
        );

        // Only cleanup if NO popups/drawers are open AND we came from filter drawer
        // This prevents false positives from cart popups
        if (!filterDrawerOpen && !anyPopupOpen && body.hasAttribute('data-filter-drawer-was-open')) {
          if (body.style.position === "fixed") {
            console.log("🔓 Filter drawer cleanup: Removing stuck position:fixed");
            body.style.position = "";
          }
          if (
            body.style.top &&
            body.style.top !== "0px" &&
            body.style.top !== "0"
          ) {
            console.log(
              "🔓 Filter drawer cleanup: Removing stuck top:",
              body.style.top
            );
            body.style.top = "";
          }
          body.removeAttribute('data-filter-drawer-was-open');
        }
        
        // Track when filter drawer opens
        if (filterDrawerOpen && !body.hasAttribute('data-filter-drawer-was-open')) {
          body.setAttribute('data-filter-drawer-was-open', 'true');
        }
      }
    });
  });

  bodyWatcher.observe(document.body, {
    attributes: true,
    attributeFilter: ["style"],
  });

  // Initialize fixes
  setTimeout(fixDrawerClearButton, 500);
  watchForLastFilterRemoval();

  // Re-apply when drawer opens
  document.addEventListener("click", function (e) {
    if (e.target.closest(".facets-toggle__button")) {
      setTimeout(fixDrawerClearButton, 300);
    }
  });
});
// 🛑 MOBILE FILTER DRAWER COMPLETE FIX

// 🟢 POPUP/OVERLAY STACKING CONTEXT FIX [11.5.25]
// Move all popup overlays to body to escape parent stacking contexts
document.addEventListener("DOMContentLoaded", function () {
  const moveOverlaysToBody = () => {
    // Find ALL popup/overlay containers
    const overlays = document.querySelectorAll(
      '[class*="ai-popup-container-"], ' +
        '[class*="ai-questionnaire-overlay-"], ' +
        '[class*="ai-lightbox-"], ' +
        '[class*="popup-overlay"], ' +
        '[class*="modal-overlay"]'
    );

    overlays.forEach((overlay) => {
      // Only move if not already a direct child of body
      if (overlay.parentElement !== document.body) {
        console.log(
          "✅ Moving overlay to body:",
          overlay.className.substring(0, 60)
        );
        document.body.appendChild(overlay);
      }
    });
  };

  // Initial move after page loads
  setTimeout(moveOverlaysToBody, 500);

  // Watch for new overlays being added dynamically
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList) {
          // Check if this is an overlay
          const className = node.className || "";
          if (
            className.includes("overlay") ||
            className.includes("popup-container") ||
            className.includes("lightbox") ||
            className.includes("modal")
          ) {
            if (node.parentElement !== document.body) {
              console.log(
                "✅ Auto-moving new overlay to body:",
                className.substring(0, 60)
              );
              document.body.appendChild(node);
            }
          }

          // Check children for overlays
          const childOverlays = node.querySelectorAll
            ? node.querySelectorAll(
                '[class*="ai-popup-container-"], ' +
                  '[class*="ai-questionnaire-overlay-"], ' +
                  '[class*="ai-lightbox-"], ' +
                  '[class*="popup-overlay"], ' +
                  '[class*="modal-overlay"]'
              )
            : [];

          childOverlays.forEach((overlay) => {
            if (overlay.parentElement !== document.body) {
              console.log(
                "✅ Auto-moving child overlay to body:",
                overlay.className.substring(0, 60)
              );
              document.body.appendChild(overlay);
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
// 🛑 POPUP/OVERLAY STACKING CONTEXT FIX
